import React from 'react';
import { StyleSheet, css } from 'aphrodite';

import Hidden from '@material-ui/core/Hidden'

// import {Link} from 'react-router-dom';

import CupMirror from '../../../assets/Achievements/CupMirror.png'

export default class SkewBg extends React.Component{

  render(){
    return(
    	<div className={css(styles.mainContainer)}>
            <section className={css(styles.skewIntro)}>
            </section>
            <Hidden smDown>
                <div className={css(styles.mirrorContainer)}>
                    <img className={css(styles.CupMirror)} src={CupMirror} alt=""/>
                </div>
            </Hidden>
        </div>
    )
  }
}

const styles = StyleSheet.create({
    mainContainer : {
        position: 'relative',
    },
    skewIntro: {
        position: 'absolute',
        zIndex: -1,
        top: 50,
        width: '100vw',
        height: 1080,
        overflow: 'hidden',
        transform: 'skewY(-12deg)',
        transformOrigin: 0,
        background: 'linear-gradient(-69deg, #FF6B4D, #D85944)',
        '@media (max-width: 768px)': {
            height: 1250,
            paddingTop: '30%',  
        }
    },
    mirrorContainer: {
        position: 'absolute',
        top: 330,
        left: 0,
        height: 400,
        zIndex: -1
    },
    CupMirror : {
        height: 'inherit',
        filter: 'drop-shadow(0px 2px 6px rgba(0,21,64,.14)) drop-shadow(0 10px 20px rgba(0,21,64,.14))'
    }
});


// WEBPACK FOOTER //
// ./src/Components/Home/Achievements/SkewBg.js